import { createSlice } from "@reduxjs/toolkit";
import { LOGIN_STEP } from "./constant";

export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        currentStep: LOGIN_STEP.SYSTEM,
    },
    reducers: {
        setLoginStep: (state, action) => {
            state.currentStep = action.payload
        }
    }
})

export default loginSlice.reducer;
export const { setLoginStep } = loginSlice.actions;
